/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientContent } from '../../models/client-content';

export interface ApiMasterClientContentGetAllGet$Params {
}

export function apiMasterClientContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterClientContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterClientContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientContent>>;
    })
  );
}

apiMasterClientContentGetAllGet.PATH = '/api/Master/ClientContent/GetAll';
